import { StepEditorProps } from "../useStepEditor";
import { AttachmentsBlock } from "../../../workflows/blocks/Attachments";
import { StepEditorAccordion } from "../../../workflows/routes/WorkflowEditor/StepEditorAccordion";
import { ErrorMessage, Field, InputHandle, Stack } from "@introist/react-foundation/v2";
import { MessageEditor } from "../../../../components/editors/MessageEditor";
import { Block, TextInput } from "../../../../components/atoms";
import { prefixForm } from "../../../../utils/FormUtils";
import { EmailStepAddressBlock } from "./EmailStepAddressBlock";
import { MessageEditor as MessageEditorV4 } from "../../../../components/editors/v4/MessageEditor/MessageEditor";
import { useFeatureFlag } from "hooks/use-feature-flag";
import { TagSelector } from "../../../system/tags/TagSelector";
import { useCallback, useRef } from "react";
import { Tag } from "../../../system/tags/useTags";
import { EmailSettings } from "./EmailSettings";

export const EmailStepEditor = ({ form, stepDataPath, workflowId }: StepEditorProps) => {
  const htmlEditorV4 = useFeatureFlag("html-editor-v4");
  const prefixedForm = prefixForm(form, stepDataPath);

  const inputRef = useRef<InputHandle>(null);

  const addTag = useCallback(
    (tag: Tag) => {
      if (!inputRef.current) return;
      inputRef.current.insertTextToCursorPosition(`{{${tag.tag}}}`);
    },
    [inputRef]
  );

  return (
    <>
      <EmailStepAddressBlock form={form} formKeyPrefix={stepDataPath} />
      <Block compact blended>
        <StepEditorAccordion
          error={
            prefixedForm.isError("subject") || prefixedForm.isError("message")
              ? "Invalid fields"
              : undefined
          }
          title="Message"
          defaultOpen={true}
        >
          <Stack vertical gap="xLarge">
            <Field title="Subject">
              <TextInput
                inputHandleRef={inputRef}
                size="small"
                placeholder="Email subject"
                value={prefixedForm.get("subject")}
                endAdornment={<TagSelector title="" size="small" onSelect={addTag} />}
                onChange={prefixedForm.set("subject")}
              />
            </Field>
            <Field title="Message">
              {htmlEditorV4.isEnabled ? (
                <MessageEditorV4
                  message={prefixedForm.get("message")}
                  onChange={prefixedForm.set("message")}
                  error={prefixedForm.isError("message")}
                  workflowId={workflowId}
                />
              ) : (
                <MessageEditor
                  message={prefixedForm.get("message")}
                  onChange={prefixedForm.set("message")}
                  tags={{
                    workflowId
                  }}
                />
              )}

              {prefixedForm.error("message") && (
                <ErrorMessage>{prefixedForm.error("message")}</ErrorMessage>
              )}
            </Field>
          </Stack>
        </StepEditorAccordion>
      </Block>
      <AttachmentsBlock form={form} />
      <EmailSettings form={form} stepDataPath={stepDataPath} />
    </>
  );
};
